//import queryString from 'querystring';
// import reduxCreator from '../libs/mk-womanizer/redux-creator';
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('VIEWS').plugin(axiosPlugin);


let updateAction = redux.fetchActionUpdate();



export const TYPES = redux.types;

export const articleViews = (id) => updateAction(`/articles/${id}/view`);
export const mediaViews = (id) => updateAction(`/medias/${id}/view`);
export const topicViews = (id) => updateAction(`/topics/${id}/view`);
export const userViews = (id) => updateAction(`/users/${id}/view`);

export const resetViews = () => redux.actions.reset();

export const views = redux.reducer();